module.exports = "//static.hsappstatic.net/marketplace-assets-base/static-1.6116/img/templates-homepage/growth-analytics-icon.svg"